import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
import { NavigationAction } from '../../NavigationAction/NavigationAction';
/**
 * Navigation action container search
 */
export const navigationActionSearchContainerStyles = ({ theme }) => css `
	flex: 1;

	@media (min-width: ${pxToRem(theme.viewportBreakpoint.lg)}) {
		display: flex;
		justify-content: flex-end;
	}
`;
export const NavigationActionSearchContainer = styled(NavigationAction) `
	${navigationActionSearchContainerStyles}
`;
